module.exports = __webpack_public_path__ + "static/media/dsp-card.c9c43b94.png";